
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M10.214 12.357V14.5h1.188m1.91 0H14.5v-2.143m0-2.571V7.214m0-2.571V2.5h-1.188m-1.91 0h-1.188v2.143m-3.428 0V2.5H2.5v12h4.286v-2.357m0-5.357L5 8.5m0 0 1.786 1.714M5 8.5h5.5"}})])
          )
        }
      }
    